import type { IWidget } from "../widget-types/types";
import type { IDataFetcher, IDataFetcherFactory } from "./IDataFetcher";
import widgetResource from "app/common/resources/widgetResource";
import {
    fetchWithFullResponseConfig,
    fetchWithFullResponseInterceptorHandlers,
} from "app/components/widget/widget-fetchers/DefaultDataFetcher";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

class SearchOrganicPaidOverviewDataFetcherFactory<T> implements IDataFetcherFactory<T> {
    create(widget: IWidget<T>): IDataFetcher<T> {
        const params = { ...widget.apiParams };
        let resource;
        if (params.webSource === devicesTypes.DESKTOP) {
            resource = widgetResource.resourceByController(
                "TrafficSourcesSearch",
                "SearchOrganicPaidOverview",
                fetchWithFullResponseConfig,
            ).PieChart;
        } else {
            resource = widgetResource.resourceByController(
                "MarketingMixTotal",
                "TrafficSourcesOverview",
                fetchWithFullResponseConfig,
            ).PieChart;
        }

        return {
            fetch: () =>
                resource(widget.apiParams)
                    .then(...fetchWithFullResponseInterceptorHandlers)
                    .then((response) => {
                        const { webSource, keys } = params;
                        if (webSource === devicesTypes.DESKTOP) {
                            return response;
                        }

                        const totalData = response.Data[webSource][keys];
                        const parsedData = {
                            [keys]: {
                                Organic: totalData["Organic Search"],
                                Paid: totalData["Paid Search"],
                            },
                        };
                        return {
                            Data: parsedData,
                        };
                    }),
            destroy: () => undefined,
        };
    }
}

export default new SearchOrganicPaidOverviewDataFetcherFactory();
